// Utility function for Google Ads conversion tracking

const GOOGLE_ADS_CONVERSION_ID = "967623456";

export const GOOGLE_ADS_CONVERSION_LABELS = {
  phoneClick: "pvPnCMTa79MaEKCGs80D",
  whatsappClick: "37sUCKvD-8sbEKCGs80D",
} as const;

/**
 * Track Google Ads conversion
 * @param conversionLabel - The conversion label from Google Ads (e.g., "KbnZCMC9xoUbEKCGs80D")
 * @param conversionType - Type of conversion (e.g., "phone_click", "whatsapp_click", "form_submit")
 */
export function trackGoogleAdsConversion(
  conversionLabel: string,
  conversionType: string
) {
  if (typeof window !== "undefined") {
    // Type assertion for dataLayer (GTM initializes it via @next/third-parties)
    const win = window as unknown as {
      dataLayer?: Array<Record<string, unknown>>;
    };

    // Initialize dataLayer if it doesn't exist
    if (!win.dataLayer) {
      win.dataLayer = [];
    }

    // Push Google Ads conversion event to dataLayer
    const conversionData = {
      event: "google_ads_conversion",
      send_to: `AW-${GOOGLE_ADS_CONVERSION_ID}/${conversionLabel}`,
      conversion_id: GOOGLE_ADS_CONVERSION_ID,
      conversion_label: conversionLabel,
      conversion_type: conversionType,
    };

    win.dataLayer.push(conversionData);

    // Debug log (remove in production if needed)
    console.log("Google Ads conversion tracked:", conversionData);
  }
}

export function trackPhoneClickConversion() {
  trackGoogleAdsConversion(
    GOOGLE_ADS_CONVERSION_LABELS.phoneClick,
    "phone_click"
  );
}

export function trackWhatsAppClickConversion() {
  trackGoogleAdsConversion(
    GOOGLE_ADS_CONVERSION_LABELS.whatsappClick,
    "whatsapp_click"
  );
}

